import React from 'react';
import { Box, TextField } from '@mui/material';

export const SelectRangoFechas = ({
  fechaDesde, // Se espera en formato "YYYY-MM-DD" o string vacío
  fechaHasta, // Se espera en formato "YYYY-MM-DD" o string vacío
  onChange,
  labelDesde = "Fecha Desde",
  labelHasta = "Fecha Hasta",
  size = "medium",
  gap = 2,
}) => {

  const handleDesdeChange = (e) => {
    const nuevaFechaDesde = e.target.value;
    
    // Si la nueva fecha desde es posterior a la fecha hasta actual, reseteamos la hasta
    // Al ser strings en formato ISO (YYYY-MM-DD), la comparación de texto funciona perfectamente
    const nuevaFechaHasta = fechaHasta && nuevaFechaDesde && nuevaFechaDesde > fechaHasta 
      ? "" 
      : fechaHasta;
      
    onChange({ fechaDesde: nuevaFechaDesde, fechaHasta: nuevaFechaHasta });
  };

  const handleHastaChange = (e) => {
    const nuevaFechaHasta = e.target.value;
    onChange({ fechaDesde, fechaHasta: nuevaFechaHasta });
  };

  return (
    <Box 
      sx={{ 
        display: 'flex', 
        gap: gap, 
        flexDirection: { xs: 'column', sm: 'row' }, 
        width: '100%' 
      }}
    >
      {/* Selector Fecha Desde */}
      <TextField
        type="date"
        label={labelDesde}
        value={fechaDesde || ""}
        onChange={handleDesdeChange}
        size={size}
        fullWidth
        slotProps={{
          inputLabel: {
            shrink: true, // Crucial en MUI v6 para que el label no se superponga con el placeholder nativo
          },
        }}
      />

      {/* Selector Fecha Hasta */}
      <TextField
        type="date"
        label={labelHasta}
        value={fechaHasta || ""}
        onChange={handleHastaChange}
        size={size}
        fullWidth
        disabled={!fechaDesde} // Mantiene tu lógica de negocio
        slotProps={{
          inputLabel: {
            shrink: true, // Mantiene el label arriba
          },
          htmlInput: {
            min: fechaDesde, // El navegador se encarga de deshabilitar los días anteriores nativamente
          },
        }}
      />
    </Box>
  );
};